<template>
    <ul class="steps steps-blue flex justify-center">
        <li v-for="step in steps" :class="[steps === 2 ? 'col-xs-6' : '', steps === 3 ? 'col-xs-4' : '', currentStep === step ? 'active' : '', 'step']">
            <a class="step-segment cursor-default" href="javascript:;">
                <span class="step-icon">
                    {{ step }}
                </span>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        steps: Number,
        currentStep: Number,
    },
};
</script>
